"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MinerUpdateData = /** @class */ (function () {
    function MinerUpdateData() {
        this.newUrl = null;
        this.newSigningKey = null;
    }
    return MinerUpdateData;
}());
exports.MinerUpdateData = MinerUpdateData;
var MiningError;
(function (MiningError) {
    MiningError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
    MiningError["database_fetch_failed"] = "database_fetch_failed";
    MiningError["api_connection_failed"] = "api_connection_failed";
    MiningError["miner_does_not_exist"] = "miner_does_not_exist";
    MiningError["account_fetch_failed"] = "account_fetch_failed";
    MiningError["duplicate_settings"] = "duplicate_settings";
    MiningError["syntactic_error"] = "syntactic_error";
    MiningError["invalid_arguments"] = "invalid_arguments";
})(MiningError = exports.MiningError || (exports.MiningError = {}));
//# sourceMappingURL=mining.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/mining.js
// module id = 228
// module chunks = 0